/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- TRIVIA ANALYTICS - TOP SKIPPED REPORT : STYLES --------------- ++++++++++ */
export default {
    topskippedreport: {
    }
};
